import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** Замена ручки billing/info */
export const billingDataForPaidInfoEnabled = isFeature('billing-data-paid-info');

/** Замена ручки billing/gift/receiving и billing/gift/giving */
export const billingDataForGiftsEnabled = isFeature('billing-data-gifts');

/** Замена ручки billing/promo/list */
export const billingDataForPromoEnabled = isFeature('billing-data-promo');

/** Замена ручек billing/subscription/expired/ios и billing/subscription/expired/android */
export const billingDataForExpiredEnabled = isFeature('billing-data-expired');

/** Включаем кэширование - только один запрос на страницу */
export const billingDataOptimizationEnabled = isFeature('billing-data-optimization');

/** Включаем получение всех периодов в ответе и клиентскую фильтрацию по периоду */
export const billingDataFilterEnabled = isFeature('billing-data-filters-enabled');

/** Переключение способа получния всех периодов в билинге
 * с billing/data?period=past,future,current (если включено)
 * на billing/data (если выключено - перейдем на этот вариант по готовности бэка)  */
export const billingDataAllFallbackEnabled = billingDataFilterEnabled && isFeature('billing-data-all-fallback-enabled');

/** Переключаем получение биллинг даты с ручки на ssr */
export const billingDataFromSsrEnabled = isFeature('billing-data-from-ssr');
